if (typeof MulticolumnSection != 'function') {
	class MulticolumnSection extends HTMLElement {
		constructor() {
			super();

			this.splideInstance = null;
			this.onSectionLoad = this.onSectionLoad.bind(this);
		}

		connectedCallback() {
			if (window.Shopify?.designMode) {
				document.addEventListener('shopify:section:load', this.onSectionLoad);
			}
			this.init();
		}

		disconnectedCallback() {
			this.destroy();
			if (window.Shopify?.designMode) {
				document.removeEventListener('shopify:section:load', this.onSectionLoad);
			}
		}

		onSectionLoad(event) {
			const sectionId = event?.detail?.sectionId;
			if (sectionId && sectionId !== this.dataset.id) return;
			this.init();
		}

		init() {
			this.layout = this.dataset.layout || 'grid';
			this.uniqueClass = `.splide--${this.dataset.id}`;
			this.slider = this.querySelector('.splide');
			this.slides = this.slider ? this.slider.querySelectorAll('.splide__slide') : [];
			this.columnsDesktop = Number(this.dataset.columnsDesktop || 3);
			this.columnsMobile = Number(this.dataset.columnsMobile || 1);
			this.showArrows = /true/.test(this.dataset.showArrows);

			if (this.layout !== 'carousel' || !this.slider || this.slides.length === 0) {
				this.destroy();
				return;
			}

			if (typeof Splide !== 'function') return;

			const slidesCount = this.slides.length;
			const perPageDesktop = Math.min(this.columnsDesktop, slidesCount);
			const perPageMobile = Math.min(this.columnsMobile, slidesCount);
			const showControls = this.showArrows && slidesCount > perPageDesktop;

			this.destroy();

			this.splideInstance = new Splide(this.uniqueClass, {
				type: 'slide',
				gap: '20px',
				perMove: 1,
				perPage: perPageDesktop,
				arrows: showControls,
				pagination: showControls,
				breakpoints: {
					1024: {
						perPage: Math.min(4, perPageDesktop),
					},
					768: {
						perPage: perPageMobile,
					},
					640: {
						perPage: perPageMobile,
					},
				},
			});

			this.splideInstance.mount();
		}

		destroy() {
			if (this.splideInstance) {
				this.splideInstance.destroy(true);
				this.splideInstance = null;
			}
		}
	}

	if (!customElements.get('multicolumn-section')) {
		customElements.define('multicolumn-section', MulticolumnSection);
	}
}
